import axios from "axios";
import React, { useState } from "react";
import Word from "./Word";
import Phonetic from "./Phonetic";
import Audio from "./Audio";
import Results from "./Results";
import Photos from "./Photos";
import "./Dictionary.css";

export default function Dictionary() {
  let [keyword, setKeyword] = useState("");
  let [word, setWord] = useState("");
  let [phonetic, setPhonetic] = useState("");
  let [audio, setAudio] = useState("");
  let [results, setResults] = useState(null);
  let [loaded, setLoaded] = useState(false);
  let [photos, setPhotos] = useState(null);

  function handleDictionResponse(response) {
    setResults(response.data[0]);
    setWord(response.data[0].word);
    setPhonetic(response.data[0].phonetic);
    setAudio(response.data[0].phonetics[0].audio);
  }

  function handlePexelsResponse(response) {
    setPhotos(response.data.photos);
  }
  function search() {
    let apiUrl = `https://api.dictionaryapi.dev/api/v2/entries/en/${keyword}`;
    axios.get(apiUrl).then(handleDictionResponse);
    let pexelsApiKey =
      "563492ad6f917000010000014d2793959116488389b5f451f0167c40";
    let pexelsUrl = `https://api.pexels.com/v1/search?query=${keyword}&per_page=4`;
    axios
      .get(pexelsUrl, { headers: { Authorization: `Bearer ${pexelsApiKey}` } })
      .then(handlePexelsResponse);
  }

  function handleSubmit(event) {
    event.preventDefault();
    search();
  }

  function handleKeywordChange(event) {
    setKeyword(event.target.value);
  }

  function load() {
    setLoaded(true);
    search();
  }

  if (loaded) {
    return (
      <div className="Dictionary">
        <h1 className="header">⚛React Dictionary⚛</h1>
        <small>What word are you looking for?</small>
        <form onSubmit={handleSubmit}>
          <input
            type="search"
            autoFocus="on"
            onChange={handleKeywordChange}
          ></input>
        </form>
        <div className="hint">examples: sunset, planet, dog</div>
        <Word word={word} />

        <Phonetic phonetic={phonetic} />
        <Audio audio={audio} />
        <Photos photos={photos} />

        <Results results={results} />
      </div>
    );
  } else {
    load();
    return "Loading...";
  }
}
